/**
 * @description 更新文档最新查看页数
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    element_id: number;
    resource_id: string;
    pages: number;
}

export const updateViewPageNum = (data: IInput): Promise<IResponse<{}>> => {
    return fetchData(Api.UPDATE_DOCUMENT_VIEW_PAGE_NUM, data).then((res: IResponse<{}>) => {
        return res;
    });
};
